import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-api-docs',
  templateUrl: './api-docs.component.html',
  styleUrls: ['./api-docs.component.scss']
})
export class ApiDocsComponent implements OnInit {
  ngOnInit(): void {
    const script = document.createElement('script');
    script.src = 'assets/api_docs/swagger-ui-bundle.js';
    script.type = 'text/javascript';
    script.onload = () => {
      // Initialize Swagger UI after the script is loaded
      const ui = (window as any).SwaggerUIBundle({
        url: 'assets/api_docs/clone_from_addipid_api_demo-swagger-apigateway.json', // Pathh to your Swagger file
        dom_id: '#swagger-ui',
      });
    };
    document.body.appendChild(script);
  }
}
